import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'admin-license-pricing-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminLicensePricingListComponent implements OnInit {

  @Input() license: any;

  constructor(private httpClient: HttpClient) {
  }

  ngOnInit() {
  }

  onAdd() {
    this.license.licensePricing.push({});
  }
}
